import React from 'react';

export default class ShOpenhouse extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    if (this.props.openhouses) {
      this.ref.current.openhouses = this.props.openhouses;
    }
  }

  render() {
    return (
      <sh-openhouse ref={this.ref}></sh-openhouse>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/sh-openhouse.js